import styled from '@emotion/styled';
import { Typography, Grid, Divider as MuiDivider } from '@mui/material';

interface HeaderProps {
  isSameItem: boolean;
  backgroundColor?: string;
  backgroundImage?: string;
  isVisible?: boolean;
  backgrounImageOpacity?: number;
  backgroundCover?: string;
  backgroundPosition?: string;
}

interface ViewerHeaderProps {
  backgroundColor?: string;
  backgroundImage?: string;
  isVisible?: boolean;
  backgrounImageOpacity?: number;
  backgroundCover?: string;
  backgroundPosition?: string;
}

interface TextProps {
  fontSize: string;
  labelFont: string;
  fontColor: string;
}

export const Container = styled.div<HeaderProps>(
  {
    height: '63px',
    width: '100%',
    borderRadius: '0 0 8px 8px',
    transition: 'opacity 0.3s ease',
    position: 'relative',
  },
  props => ({
    position: props.isVisible ? 'relative' : 'absolute',
    background: props.backgroundColor,
    top: props.isVisible ? '0' : '-35px',
    border: props.isSameItem && props.isVisible ? '1px solid #265183' : 'none',
    '&:hover ': {
      border: '1px solid #265183',
      backgroundColor: '#f6f8fb',
    },
    '&:hover .containerTag ': {
      opacity: '1',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundImage: `url(${props.backgroundImage})`,
      opacity: props.isVisible ? `${props.backgrounImageOpacity}` : '0',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: props.backgroundPosition,
      backgroundSize: props.backgroundCover,
      inset: 0,
      borderRadius: 'inherit',
    },
  })
);

export const ViewerContainer = styled.div<ViewerHeaderProps>(
  {
    height: '63px',
    width: '100%',
    borderRadius: '0 0 8px 8px',
    transition: 'opacity 0.3s ease',
    position: 'relative',
  },
  props => ({
    background: props.backgroundColor,
    border: 'none',
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundImage: `url(${props.backgroundImage})`,
      opacity: props.isVisible ? `${props.backgrounImageOpacity}` : '0',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: props.backgroundPosition,
      backgroundSize: props.backgroundCover,
      inset: 0,
      borderRadius: 'inherit',
    },
  })
);

export const Text = styled(Typography)<TextProps>({}, props => ({
  fontSize: props.fontSize,
  fontFamily: props.labelFont,
  color: props.fontColor,
}));

export const Divider = styled(MuiDivider)({
  marginBottom: '16px',
});

export const ButtonContainer = styled.div<HeaderProps>({
  position: 'absolute',
  height: '100%',
  width: '100%',
  display: 'flex',
  zIndex: 99,
  borderRadius: '0 0 8px 8px',
  justifyContent: 'center',
  gap: '16px',
  alignItems: 'center',
  opacity: '0',
  top: 0,
  left: 0,
  '&:hover ': {
    opacity: '1',
    background: 'white',
  },
});

export const Tag = styled.div<HeaderProps>(
  {
    position: 'absolute',
    background: '#265183',
    color: 'white',
    padding: '10px',
    width: '100px',
    textAlign: 'center',
    borderRadius: '8px 8px 0 0',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    opacity: '0',
  },
  props => ({
    ...(props.isSameItem && { opacity: '1' }),
  })
);

export const GridContainer = styled(Grid)({
  padding: ' 8px 24px',
  height: '100%',
});

export const GridItemImage = styled(Grid)({
  height: '100%',
  zIndex: 1,
});

export const ImageElement = styled.img({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});

export const GridItemText = styled(Grid)({
  textAlign: 'right',
  zIndex: 1,
});
